import { render } from "./IosEnglish.vue?vue&type=template&id=0236dc71&scoped=true"
import script from "./IosEnglish.vue?vue&type=script&lang=js"
export * from "./IosEnglish.vue?vue&type=script&lang=js"

import "./IosEnglish.vue?vue&type=style&index=0&id=0236dc71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0236dc71"]])

export default __exports__